import LLM from '../LLM';
import SetupPortalPage from '../../components/setup/SetupPortalPage';

/**
 * Chat sub-page inside the agent setup portal.
 * Renders the LLM chat UI and adds an "Open in new tab" link to /llm.
 */
function AgentChatPage() {
    return (
        <SetupPortalPage>
            <div style={{ position: 'relative' }}>
                <div style={{ marginBottom: '12px' }}>
                    <a href="/llm" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 500 }}>
                        Open in new tab ↗
                    </a>
                </div>
                <LLM />
            </div>
        </SetupPortalPage>
    );
}

export default AgentChatPage;
